import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FishDisease from "../../../../components/Operation/FishDisease";
import UnitLice from "../../../../components/Operation/UnitLice";
import { openPopup } from "../../../../components/Popup/_components/WrapperPopup";
import { useBiology } from "../../../../contexts/PlanOperationContext/Biology";
import { setTabBiology } from "../../../../contexts/PlanOperationContext/TabBiology";
import { selectSetting } from "../../../../util/store/selectors";
import { KEY_TAB, OPERATION_TYPE, SITE_TYPE } from "../../../../util/varibles/constants";
import { ISite, IUnit } from "../../../../util/varibles/interface";
import { PlanSetting } from "../../../../util/varibles/userSetting";
import { selectPlan } from "../../constants";
import Site from "../../Popup/Site";
import { planOpActions } from "../../reducer";
import Cards from "../_components/Cards";
import Card from "../_components/Cards/Card";
import FishAndWeight from "../_components/FishAndWeight";
import Location from "../_components/Location";
import UnitDiseases from "../_components/UnitDiseases";
import { UnitModel } from "../constants";
import stylesContainer from "../style.module.scss";
import HeaderSmolt from "./HeaderSmolt";

interface IState {
    searchValue: string
    weightFilter: [number | null, number | null],
}

const initState: IState = {
    searchValue: '',
    weightFilter: [null, null],
}


const SmoltSite: React.FC = () => {
    const loading = useSelector(selectPlan.loadingSites);
    const {
        [PlanSetting.SMOLT_SITE]: smoltFilter = [],
        [PlanSetting.SMOLT_PROD_AREA]: smoltProdAreaFilter = [],
        [PlanSetting.SMOLT_LICE_SORT]: liceSort = null
    } = useSelector(selectSetting([PlanSetting.SMOLT_SITE, PlanSetting.SMOLT_PROD_AREA, PlanSetting.SMOLT_LICE_SORT]))
    const [form, setForm] = useState(initState);
    const [smoltSites, set] = useBiology(state => state.smoltSites);
    const setTab = setTabBiology();
    const dispatch = useDispatch();

    useEffect(() => {
        set(({ clear }) => ({
            clear: { ...clear, smolt: () => setTab({ selected: {} }) }
        }))
    }, [set, setTab]);

    const { searchValue, weightFilter } = form;
    const countSite = smoltFilter.length;
    const countProdArea = smoltProdAreaFilter.length;
    const listOfSiteFilter = new Set(smoltFilter);
    const listOfProdAreaFilter = new Set(smoltProdAreaFilter);
    const [minWeight, maxWeight] = weightFilter;
    const liceInSites: ISite[] = [];
    const normal = smoltSites.reduce((list: any[], site: ISite) => {
        const { id, name, prod_area = '', units = [] } = site
        const isSearch = searchValue.length === 0
            || (searchValue.length > 0 && name.indexOf(searchValue.toLowerCase()) !== -1)
        if (!isSearch) return list;

        const isSite = (countSite === 0 || listOfSiteFilter.has(id))
            && (countProdArea === 0 || listOfProdAreaFilter.has(prod_area))
        if (!isSite) return list;

        const { lice } = site.diseases || {};
        if (lice && lice[liceSort]) {
            liceInSites.push(site)
            return list;
        }

        return [...list, ...units.reduce((items: any, unit: IUnit) => {
            const { avg_weight = 0, fish_amount } = unit;
            const isMin = minWeight ? (minWeight <= avg_weight && fish_amount) : true;
            if (!isMin) return items;

            const isMax = maxWeight ? (maxWeight >= avg_weight && fish_amount) : true;
            if (!isMax) return items;

            return [...items, UnitModel(unit, site)]
        }, [])]
    }, [])
    const units = [
        ...liceInSites
            .sort((a: ISite, b: ISite) => {
                const { [liceSort]: liceA } = a.diseases?.lice || {};
                const { [liceSort]: liceB } = b.diseases?.lice || {};
                return liceB.value - liceA.value
            })
            .reduce((rs: any, site) => [...rs, ...site.units.reduce((items: any, unit: IUnit) => {
                const { avg_weight, fish_amount } = unit;
                const isMin = minWeight ? (minWeight <= avg_weight && fish_amount) : true;
                const isMax = maxWeight ? (maxWeight >= avg_weight && fish_amount) : true;

                if (!isMin || !isMax)
                    return items;
                return [...items, UnitModel(unit, site)]
            }, [])], []),
        ...normal
    ];

    const handleOpenSite = (unit: IUnit) => {
        const el = openPopup(<Site
            site={{ id: unit.site_id || '', name: unit.site_name || '' }}
            unitId={unit.id}
            onUpdate={value => dispatch(planOpActions.updateSite(value))}
            onClose={() => el.remove()}
        />)
    }


    return <div id={KEY_TAB.SMOLT} className={stylesContainer['wrapper-tab']}>
        <HeaderSmolt {...{
            searchValue,
            liceSort,
            weightFilter,
            handleSearch: value => setForm(prev => ({ ...prev, ...value })),
            sites: smoltSites
        }} />
        <div className={stylesContainer['tab-body']}>
            <Cards<IUnit>
                data={units}
                loading={loading}
                child={{
                    height: 80,
                    View: ({ data }) => {
                        const { unit_id, site_name = '', fish_amount, type, diseases = [], lice } = data;
                        const isInternal = type === SITE_TYPE.INTERNAL;
                        const isActive = !(isInternal && fish_amount <= 0);

                        return <Card
                            data={data}
                            isActive={isActive}
                            key={data.id}
                            style={{ height: '80px', maxHeight: '80px' }}
                            types={[OPERATION_TYPE.TRANSPORT]}
                            onContext={() => handleOpenSite(data)}
                        >
                            <div className={stylesContainer.line}>
                                <div className={stylesContainer.infoLine}>
                                    <Location source={[site_name, `, ${unit_id}`]} />
                                    {isInternal && <FishAndWeight data={data} />}
                                </div>
                                <div className={stylesContainer.infoLine} data-right={true}>
                                    <UnitLice lice={lice} />
                                    <FishDisease diseases={diseases} units={[data]} short={true} />
                                    <UnitDiseases data={data.unit_diseases} />
                                </div>
                            </div>
                        </Card>
                    }
                }}
            />
        </div>
    </div>;
};

export default SmoltSite;

